import { render, staticRenderFns } from "./MilkFeedingRequirement.vue?vue&type=template&id=297e51ac&scoped=true&"
import script from "./MilkFeedingRequirement.vue?vue&type=script&lang=js&"
export * from "./MilkFeedingRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e51ac",
  null
  
)

export default component.exports